export class LoggingServiceConfig {
  public applicationName = 'APP_NAME_NOT_PROVIDED';
  public version: string;
}
